<template>
<header id="mainheader">
    <svg id="header_shape" viewBox="0 0 1900 238" preserveAspectRatio="none" aria-hidden="true">
        <rect class="r2" width="131.94" height="235" />
        <rect class="r3" x="148.66" width="132.67" height="235" />
        <rect class="r4" x="602.78" width="44.22" height="235" />
        <rect class="r5" x="716.57" width="151.01" height="235" />
        <rect class="r1" x="1187.4" width="78.2" height="235" />
        <rect class="r7" x="1787.67" width="145.33" height="235" />
        <rect class="r6" x="1338.42" width="124.04" height="235" :style="searchStyles"/>
    </svg>
    <div id="sitename">
        <router-link :to="`/`">
        <svg id="title_paths" aria-label="Fizykoteka - Wirtualne muzeum wydziału Fizyki UW" viewBox="0 0 746.5 133.7">
            <g>
                <path d="M7.4,11.5h38.8v8.6H17.3V43H44v8.5H17.3V79H7.4V11.5z"/>
                <path d="M53,11.5h9.9V79H53V11.5z"/>
                <path d="M70.6,11.5h43.8L83.9,70.2h29.4V79H69.2l30.7-58.9H70.6V11.5z"/>
                <path d="M141.1,53l-22.9-41.6h11.1L146,43.3h0.4l16.9-31.9h11L151,53.2V79h-9.9V53z"/>
                <path d="M180.4,11.5h9.9v29.8c1.8,0.4,4,0.4,5.9,0.4c11.8,0,19.8-7.5,19.8-20.1c0-3.1-0.1-7-0.3-10.1h9.9
                    c0.2,3.2,0.3,6.7,0.3,9.7c0,13.5-6.3,23-17.4,27.2L229,79H217l-18.7-28.5c-1,0.1-2,0.1-3,0.1c-1.6,0-3.3-0.1-4.9-0.3V79h-9.9V11.5z
                    "/>
                <path d="M230.8,45.2c0-20.3,14.5-35.2,34.4-35.2s34.3,14.8,34.3,35.2c0,20.3-14.4,35.2-34.3,35.2
                    C245,80.4,230.8,65.6,230.8,45.2z M289.4,45.1c0-15.2-9.9-26.3-24.2-26.3S241,29.9,241,45.1c0,15.4,9.9,26.3,24.2,26.3
                    S289.4,60.5,289.4,45.1z"/>
                <path d="M317.7,20.1h-18v-8.6h45.9v8.6h-18V79h-9.9V20.1z"/>
                <path d="M351.8,11.5h38.7v8.6h-28.8v20.4h27v8.5h-27v21.1H391V79h-39.1V11.5z"/>
                <path d="M399.9,11.5h9.9v29.8c1.8,0.4,4,0.4,5.9,0.4c11.8,0,19.8-7.5,19.8-20.1c0-3.1-0.1-7-0.3-10.1h9.9
                    c0.2,3.2,0.3,6.7,0.3,9.7c0,13.5-6.3,23-17.4,27.2L448.5,79h-12.1l-18.7-28.5c-1,0.1-2,0.1-3,0.1c-1.6,0-3.3-0.1-4.9-0.3V79h-9.9
                    V11.5z"/>
                <path d="M474.8,11.5h12.8L510.1,79h-10.6l-5.3-17H468l-5.4,17h-10.3L474.8,11.5z M470.8,53.2h20.6l-10.1-32H481
                    L470.8,53.2z"/>
                <path d="M17.5,103.3h-0.1l-5.5,20.1H7.6L0.9,95.6h4.4l4.7,20.9h0.1l5.5-20.9h3.7l5.7,20.9h0.1l4.7-20.9h4.3l-6.7,27.8
                    h-4.3L17.5,103.3z"/>
                <path d="M37.3,95.6h4.1v27.8h-4.1V95.6z"/>
                <path d="M55.2,112.3H51v11.1h-4.1V95.6h10.2c5.3,0,9.1,3.6,9.1,8.3c0,4-2.7,7.1-6.7,8.1l7,11.4h-4.7L55.2,112.3z
                     M62.2,104c0-2.7-2-4.8-5.4-4.8H51v9.7h5.8C60.1,108.8,62.2,106.6,62.2,104z"/>
                <path d="M75.5,99.2h-7.4v-3.6h18.9v3.6h-7.4v24.2h-4.1V99.2z"/>
                <path d="M110.4,113.7c0,6-4,10.3-10.3,10.3c-6.3,0-10.3-4.3-10.3-10.3V95.6h4.1V114c0,3.7,2.6,6.3,6.2,6.3
                    c3.7,0,6.2-2.6,6.2-6.3V95.6h4.1V113.7z"/>
                <path d="M121.5,95.6h5.3l9.3,27.8h-4.4l-2.2-7h-10.8l-2.2,7h-4.2L121.5,95.6z M119.9,112.8h8.5l-4.1-13.2H124
                    L119.9,112.8z"/>
                <path d="M139,95.6h4.1v24.2h11v3.6H139V95.6z"/>
                <path d="M174.5,123.4l-13.2-20.5h-0.1v20.5h-4V95.6h4.3l13.2,20.5h0.1V95.6h4v27.8H174.5z"/>
                <path d="M184.3,95.6h15.9v3.6h-11.8v8.4h11.1v3.5h-11.1v8.7h12v3.6h-16.1V95.6z"/>
                <path d="M226.3,116.7l-7.7-14.2h-0.1v20.8h-4V95.6h5.1l8.4,16.1h0.1l8.5-16.1h4.8v27.8h-4v-20.8h-0.1l-7.6,14.2H226.3z
                    "/>
                <path d="M267.5,113.7c0,6-4,10.3-10.3,10.3c-6.3,0-10.3-4.3-10.3-10.3V95.6h4.1V114c0,3.7,2.6,6.3,6.2,6.3
                    c3.7,0,6.2-2.6,6.2-6.3V95.6h4.1V113.7z"/>
                <path d="M270.7,95.6h18l-12.5,24.2h12.1v3.6h-18.2l12.6-24.2h-12V95.6z"/>
                <path d="M291.7,95.6h15.9v3.6h-11.8v8.4h11.1v3.5h-11.1v8.7h12v3.6h-16.1V95.6z"/>
                <path d="M331.9,113.7c0,6-4,10.3-10.3,10.3c-6.3,0-10.3-4.3-10.3-10.3V95.6h4.1V114c0,3.7,2.6,6.3,6.2,6.3
                    c3.7,0,6.2-2.6,6.2-6.3V95.6h4.1V113.7z"/>
                <path d="M349.1,116.7l-7.7-14.2h-0.1v20.8h-4V95.6h5.1l8.4,16.1h0.1l8.5-16.1h4.8v27.8h-4v-20.8h-0.1l-7.6,14.2H349.1z
                    "/>
                <path d="M394.1,103.3h-0.1l-5.5,20.1h-4.3l-6.7-27.8h4.4l4.7,20.9h0.1l5.5-20.9h3.7l5.7,20.9h0.1l4.7-20.9h4.3
                    l-6.7,27.8h-4.3L394.1,103.3z"/>
                <path d="M422.1,112.7l-9.4-17.1h4.6l6.9,13.1h0.1l7-13.1h4.5l-9.5,17.2v10.6h-4.1V112.7z"/>
                <path d="M438.7,123.4V95.6h9.2c8.5,0,14.2,5.3,14.2,13.8c0,8.5-5.7,13.9-14.2,13.9H438.7z M457.9,109.5
                    c0-6.5-3.9-10.3-10.1-10.3h-5.1v20.6h5.1C454,119.8,457.9,115.9,457.9,109.5z"/>
                <path d="M462.9,95.6h18l-12.5,24.2h12.1v3.6h-18.2L475,99.2h-12V95.6z"/>
                <path d="M484,95.6h4.1v27.8H484V95.6z"/>
                <path d="M500.2,95.6h5.3l9.3,27.8h-4.4l-2.2-7h-10.8l-2.2,7H491L500.2,95.6z M498.6,112.8h8.5l-4.1-13.2h-0.1
                    L498.6,112.8z"/>
                <path d="M518.3,112l-2.6,0.9l-0.8-2.1l3.3-1.2v-14h4.1v12.5l7.5-2.7l0.8,2.1l-8.3,3v9.3h11v3.6h-15.1V112z"/>
                <path d="M556.1,113.7c0,6-4,10.3-10.3,10.3c-6.3,0-10.3-4.3-10.3-10.3V95.6h4.1V114c0,3.7,2.6,6.3,6.2,6.3
                    c3.7,0,6.2-2.6,6.2-6.3V95.6h4.1V113.7z"/>
                <path d="M571.2,95.6h15.9v3.6h-11.9v9.4h11v3.5h-11v11.3h-4.1V95.6z"/>
                <path d="M590.3,95.6h4.1v27.8h-4.1V95.6z"/>
                <path d="M598,95.6h18l-12.5,24.2h12.1v3.6h-18.2L610,99.2h-12V95.6z"/>
                <path d="M627.3,112.7l-9.4-17.1h4.6l6.9,13.1h0.1l7-13.1h4.5l-9.5,17.2v10.6h-4.1V112.7z"/>
                <path d="M643.8,95.6h4.1v12.2c0.7,0.1,1.6,0.1,2.4,0.1c4.8,0,8.1-3.1,8.1-8.3c0-1.3,0-2.9-0.1-4.1h4.1
                    c0.1,1.3,0.1,2.8,0.1,4c0,5.6-2.6,9.5-7.1,11.2l8.4,12.6h-5l-7.7-11.7c-0.4,0-0.8,0-1.2,0c-0.7,0-1.4,0-2-0.1v11.8h-4.1V95.6z"/>
                <path d="M666.9,95.6h4.1v27.8h-4.1V95.6z"/>
                <path d="M706.6,113.7c0,6-4,10.3-10.3,10.3c-6.3,0-10.3-4.3-10.3-10.3V95.6h4.1V114c0,3.7,2.6,6.3,6.2,6.3
                    c3.7,0,6.2-2.6,6.2-6.3V95.6h4.1V113.7z"/>
                <path d="M726.3,103.3h-0.1l-5.5,20.1h-4.3l-6.7-27.8h4.4l4.7,20.9h0.1l5.5-20.9h3.7l5.7,20.9h0.1l4.7-20.9h4.3
                    l-6.7,27.8H732L726.3,103.3z"/>
            </g>
        </svg>
        </router-link>
    </div>
    <svg id="search" viewBox="0 0 526 526" @click="openSearch" v-bind:class="{'go-up' : searchOpened}" v-if="this.$route.name != 'Index'">
        <circle cx="221.3" cy="222.3" r="202.8"/>
        <line class="line" x1="518" y1="518" x2="363.2" y2="367.2"/>
    </svg>
    <svg id="hamburger" viewBox="0 0 250 175" @click="isMenuActive" v-bind:class="{'go-up' : searchOpened}">
        <line x1="0" y1="12" x2="250" y2="12"/>
        <line x1="0" y1="87" x2="250" y2="87"/>
        <line x1="0" y1="162" x2="250" y2="162"/>
    </svg>
    <form @submit="submitted" class="search-form" v-bind:class="{'shown' : searchOpened}" v-if="this.$route.name != 'Index'">
        <div class="search-wrapper">
            <div class="adv-search"><router-link title="Wyszukiwanie zaawansowane" :to="'/zaawansowane'">...</router-link></div> 
            <div class="input-wrapper">
                    <input v-model="query"/>
            </div>
            <button>Szukaj</button>
        </div>
    </form>
</header>
</template>
<script>
// search form
import Vivus from 'vivus'
import {
    eventBus
} from '@/main.js'

export default {
    name: 'Header',
    data() {
        return {
            query: null,
            searchOpened: false,
            searchStyles: String,
            key: Math.random()
        }
    },
    /* created () {
        this.$loadScript('/static/assets/vue-js/scripts.js')
                .then(() => {
                    this.setCookie
            })
    },  */
    methods: {
        openSearch() {

            this.searchOpened = !this.searchOpened

            if (this.searchOpened) {

                //console.log('search opened')

                let form = $('.search-form'),
                coords = form.offset(),
                coordsContainer = $('body>.container').offset()
                //console.log(coords)


                var scale = 1900 / +$('body>.container').width(); // 1900 is original width of graphic, this provides scalability to rectagular

                scale = scale.toFixed(6);

                this.searchStyles = {
                    x: (coords.left - coordsContainer.left - 10) * scale,
                    y: coords.top * scale,
                    width: (scale * (form.width() + 30) / 16) + 'rem',
                    height: (scale * (form.height() + 15) / 16) + 'rem',
                    fill: '#465165',
                    stroke: '#465165',
                    transition: '.5s',
                    'stroke-dasharray': '0',
                }



                if (navigator.userAgent.indexOf("Firefox") > 0) {
                    
                    // ff bug with offset()
                    let _searchStyles = {}
                    _searchStyles.x = this.searchStyles.y
                    _searchStyles.y = this.searchStyles.x
                    this.searchStyles = _searchStyles 
                    $('.search-wrapper').css('padding','2px');
                    $('.search-wrapper').css('width','100%');
                    $('.search-wrapper').css('background','#465165');

                }

                //console.log(this.searchStyles)
                
                let scale = 1900 / +$('body>.container').width(); // 1900 is original width of graphic, this provides scalability to rectagular

                scale = scale.toFixed(6);
                //console.log(scale);
                setTimeout(function() {
                    //$('.search-wrapper').css('background','#465165');
                    //$('.header_shape r6').css('fill','red');
                    $('.search-form input').focus();

                }, 500);

            } else {
                //console.log('search NOT opened')

                this.searchStyles = ''
            }
        },
        submitted() {
            this.$router.push({
                name: 'Search',
                params: {
                    query: this.query
                }
            })
        },
        isMenuActive() {
            eventBus.$emit('isMenuActive', true);
        }
    }
}
</script>
<style scoped>

.adv-search a {
    color: white;
}
.adv-search a:hover {
    color: #c63;
}

.search-form .search-wrapper {
    align-items: flex-end;
}

</style>


// WEBPACK FOOTER //
// src/components/Header/Header.vue